import Wheel from './../components/wheel';

export default class Hub {
    constructor() {
    	new Wheel();
    }
}